import {
  hardCodeIsCaesarStone,
  hardCodeIsLowes,
  hardCodeIsMcDermott,
  hardCodeIsModerno,
  hardCodeIsPorcelanosa,
  isProd
} from "../../misc/fabricatorHardcode";

export const isDevMode = () => {
  return window.location.href.includes("dev=1") || document.kvConfig.devMode
};

export const SQFT_POST_MESSAGE_ACTIONS = {
  initialLoad: "initialLoad",
  setQTData: "setQTData",
  closeSqFtCalc: "closeSqFtCalc",
  callResetDataPopup: "callResetDataPopup",
  callChangeLayoutDataPopup: "callChangeLayoutDataPopup",
  userIdleResetCounter: "userIdleResetCounter",
  resetHistory: "resetHistory",
  saveHistory: "saveHistory",
  setNewLayoutOnSqft: "setNewLayoutOnSqft",
  setCanvasCenter: "setCanvasCenter",
  stopRender: "stopRender",
  startRender: "startRender",
};

export const MEASURE_UNITS = {
  Metric: "Metric",
  Imperial: "Imperial",
};

/**
 *
 * This is used only to take shape part id
 * @type {{top_cabinet: string, bottom_cabinet: string, center_island_countertop: string, slabPlaceHolder: string, seamPiece: string, countertop: string, spacer: string, vanity_countertop: string, backsplashPiece: string}}
 */
export const SHAPE_PART_ID = {
  edge: 'edge',
  seamPiece: 'seamPiece',
  backsplashPiece: 'backsplashPiece',
  waterfallPiece: 'waterfallPiece',
  slabPlaceHolder: 'slabPlaceHolder',
  top_cabinet: 'top_cabinet',//
  bottom_cabinet: 'bottom_cabinet',//
  tall_cabinet: 'tall_cabinet', //
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  tall_cabinet_boxes: 'tall_cabinet_boxes',
  countertop: 'countertop',
  spacer: 'spacer',
  vanity_countertop: 'vanity_countertop',
  center_island_countertop: 'center_island_countertop',
  front_wall: 'front_wall',

  //appliances
  dishwasher: "dishwasher",
  hood: "hood",
  fridge: "fridge",
  stove: "stove",
};

export const APPLIANCE_PART_IDS = [
  SHAPE_PART_ID.dishwasher,
  SHAPE_PART_ID.hood,
  SHAPE_PART_ID.fridge,
  SHAPE_PART_ID.stove,
]

export const FEATUREGROUP_PART_ID = {
  specialty_cut_and_designs: 'specialty_cut_and_designs'
}

export const SHAPE_ROTATE_DIRECTION = {
  right: 0,
  left: 1,
};

export const ALIGN = {
  right: 'right',
  left: 'left',
  center: 'center',
};

export const SHAPE_TYPE = {
  polygon: "polygon",
  square: "square",
  wideangle: "wideangle",
  horseshoe: "horseshoe",
  appliances: "appliances",
};

export const RENDER_TEMPLATES = {
  default: "default",
  linesOnly: "linesOnly",
  filledPrimary: "filledPrimary",
  accordingToFeature: "accordingToFeature",
  filledActive: "filledActive",
};

/**
 * NAVIGATION
 */
export const SIDEBAR2_BUTTONS = [
  {
    menu: "summary",
    classNames: "button--parent button--summary",
    text: "mobile.summary",
    hasMenu: true
  },
  // {
  //   menu: "settings",
  //   classNames: "button--parent button--settings",
  //   text: "settings",
  //   hasMenu: true
  // }
];

export const SIDEBAR_BUTTONS_MENU = {
  move: "move",
  shapes: "shapes",
  layouts: "layouts",
  summary: "summary",
  delete: "delete",
  cabinetset: "cabinetset"
}

export const SIDEBAR_SLAB_BUTTONS = {
  move: "move",
  //moveSlab: "moveSlab",
  rotate: "rotate",
  loadSlab: "loadSlab",
  seam: "seam",
  duplicate: "duplicate",
  delete: "delete",
};

export const MOVABLE_IMAGE_TYPES = {
  slabImage: "slabImage",
};

export const SIDEBAR_SLAB_SEAM_BUTTONS = {
  //addFreeSeam: "addFreeSeam", //todo enable when ready
  addSeamHorizontal: "addSeamHorizontal",
  addSeamVertical: "addSeamVertical",
  undoSeam: "undoSeam",
  resetSeams: "resetSeams",
};

/**
 * remember to update SIDEBAR_HIDDEN_BUTTONS (names should be the same)
 */
export const SIDEBAR_NAVIGATION_BUTTONS = {
  move: "move",
  //freeDraw: "freeDraw",
  resize: "resize",
  rotate: "rotate",
  corners: "corners",
  radius: "radius",
  edge: "edge",
  backsplash: "backsplash",
  end_cap: "end_cap",
  appliances: "appliances",
  angle: "angle",
  bumpout: "bumpout",
  label: "label",
  text: "text",
  ...((!hardCodeIsLowes()) && { mitered: "mitered" }),
  ...((!hardCodeIsMcDermott() && !hardCodeIsLowes()) && { toolWaterfall: "toolWaterfall" }),
  ...((!isProd && (hardCodeIsModerno() || hardCodeIsPorcelanosa() || isDevMode())) && { toolUnderlayment: "toolUnderlayment" }),
  duplicate: "duplicate",
};

export const SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS = {
  move: "move",
  freeDraw: "freeDraw",
  resize: "resize",
  rotate: "rotate",
  corners: "corners",
  edge: "edge",
  bumpout: "bumpout",
  mitered: "mitered",
  ...((hardCodeIsModerno() || hardCodeIsPorcelanosa() || isDevMode()) && {toolWaterfall: "toolWaterfall"}),
  appliances: "appliances",
  label: "label",
  text: "text",
  duplicate: "duplicate",
};

export const SIDEBAR_NAVIGATION_CABINET_BUTTONS = {
  move: "move",
  resize: "resize",
  rotate: "rotate",
  lower: "lower",
  upper: "upper",
  tall: "tall",
  centerIsland: "centerIsland",
  spacer: "spacer",
  //style: "style",
  wall: "wall",
  crown: "crown",
  handles: "handles",
  hinge: "hinge",
  // top_handle: "top_handle",
  // bottom_handle: "bottom_handle",
  end_panel: "end_panel",
  appliances: "appliances", // disable appliances for caes
  text: "text",
};

export const SIDEBAR_SHAPE_BUTTONS = {
  square: "square",
  lshape: "lshape",
  wideangle: "wideangle",
  rectangle: "rectangle",
  dot: "dot",
  freeDraw: "freeDraw",
  shapeFreeForm: "shapeFreeForm",
};

export const SIDEBAR_NAVIGATION_BUTTONS_LEVEL3 = {
  filters: "filters",
};

export const FREE_FORM_THICKNESS_POPUP_ID = "freeForm";

export const SIDEBAR_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.tools",
    shouldHardcodeMessage: true,
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_BUTTONS
  }, {
    menu: "shapes",
    message: "sqft.navigation.menu.shapes",
    hasMenu: true,
    subMenu: SIDEBAR_SHAPE_BUTTONS
  }, {
    menu: "layouts",
    message: "sqft.navigation.menu.layouts",
    hasMenu: true
  }, {  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }, {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },
  // {
  //   menu: "settings",
  //   message: "sqft.navigation.menu.settings"
  // },
];

export const SIDEBAR_TYPE_AREA_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_BUTTONS
  }, {
    menu: "shapes",
    message: "sqft.navigation.menu.shapes",
    hasMenu: true,
    subMenu: SIDEBAR_SHAPE_BUTTONS
  }, {  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }, {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },
];

export const SIDEBAR_CABINET_BUTTONS = [
  {
    menu: "move",
    message: "sqft.navigation.menu.move",
    hasMenu: true,
    subMenu: SIDEBAR_NAVIGATION_CABINET_BUTTONS
  }, {  // disable summary for caes
    menu: "summary",
    message: "sqft.navigation.menu.summary",
    hasMenu: true
  }, {
    menu: "delete",
    message: "sqft.navigation.menu.delete",
    title: "Remove an object from the workspace", //todo translation
    additionalClassNames: "dot-delete"
  },...(isDevMode() ? [{
    menu: "cabinetset",
    message: "Cabinet Set",
  }] : []),
  // {
  //   menu: "settings",
  //   message: "sqft.navigation.menu.settings"
  // },
];

export const SIDEBAR_WITH_FEATURES_SUBMENU = [
  SIDEBAR_NAVIGATION_BUTTONS.end_cap,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.hinge,
];

export const SHOULD_DISPLAY_FEATURES_ONLY_WITH_AR3DUrls = [
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles
];

export const SIDEBAR_HIDDEN_BUTTONS = {
  mitered: "mitered",
  toolWaterfall: "toolWaterfall",
  toolUnderlayment: "toolUnderlayment",
  buttonMitered: "buttonMitered",
  buttonCustomBacksplash: "buttonCustomBacksplash",
  edgePeninsulaUnderwrap: "edgePeninsulaUnderwrap",
};

/*
* Hide shapes after removing them in popup window
*/
export const isDisabledInPopupShouldBeHidden = () => {
  return hardCodeIsCaesarStone() //enabled only for caesarstone
}

export const SIDEBAR_LAYOUTS_BUTTONS = [
  "S", "SP", "SI", "SPI", "SN", "SPN", "SNI", "SPNI", "L", "LI", "LN", "LNI"
];

export const SQFT_APPLIANCES = {
  hood: "hood",
  refrigerator: "refrigerator",
  range: "range",
  sink: "sink",
  doubleSink: "doubleSink",
  dishwasher: "dishwasher",
  iceMachine: "ice machine",
  oven: "oven",
  stovetop: "stovetop",
  trashCompactor: "trash compactor",
  wineFridge: "wine fridge"
};

export const SQFT_APPLIANCES_BATHROOM = {
  tub: "tub",
  toilet: "toilet",
  vanity: "vanity",
  wet_space: "wet space"
};

export const SQFT_APPLIANCES_CAES = {
  hood: "hood",
  sink: "sink",
  stovetop: "stovetop",
};

export const CABINET_LABELS = {
  top_cabinet: 'top_cabinet',
  bottom_cabinet: 'bottom_cabinet',
  tall_cabinet: 'tall_cabinet',
  crown_molding: 'crown_molding',
  tall_cabinet_boxes: 'tall_cabinet_boxes',
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  handle: 'handle',
};

export const CABINET_BOXES = [
  SHAPE_PART_ID.lower_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.tall_cabinet_boxes,
];

export const SQFT_CABINET_APPLIANCES = {
  //hood: "hood",
  //microwave: "microwave",
};

export const SQFT_APPLIANCES_WITH_SUBMENU = [
  SQFT_APPLIANCES.oven,
  SQFT_APPLIANCES.hood,
  SQFT_APPLIANCES.dishwasher,
  SQFT_APPLIANCES.stovetop,
  SQFT_APPLIANCES.refrigerator,
  SQFT_APPLIANCES.range,
  SQFT_CABINET_APPLIANCES.microwave,
  //partIds which names are mismatched
  SHAPE_PART_ID.stove,
  SHAPE_PART_ID.fridge,
]

export const SQFT_SHAPES_THAT_ADD_OVERHANG = [
  SQFT_APPLIANCES.oven,
  SQFT_APPLIANCES.range,
  SQFT_APPLIANCES.hood,
  SQFT_APPLIANCES.dishwasher,
  SQFT_APPLIANCES.stovetop,
  SQFT_APPLIANCES.refrigerator,
  CABINET_LABELS.tall_cabinet_boxes,
  //CABINET_LABELS.lower_cabinet_boxes,
  //partIds which names are mismatched
  SHAPE_PART_ID.stove,
  SHAPE_PART_ID.fridge,
]

export const SQFT_MODE = {
  regular: "regular",
  slab: "slab",
};

export const SQFT_VIEW_MODE = {
  twoDMode: "2d Mode",
  threeDMode: "3d Mode",
  threeDModeDoors: "3d Mode Doors",
  threeDModeFramed: "Framed",
  threeDModeFrameless: "Frameless",
  augmentedReality: "Augmented Reality",
  augmentedRealityCabinet: "Augmented Reality Cabinet",
  augmentedRealityDoorsOnly: "Augmented Reality Doors Only"
}
export const SQFT_VIEW_AR_MODES = [
  SQFT_VIEW_MODE.augmentedReality,
  SQFT_VIEW_MODE.augmentedRealityCabinet,
  SQFT_VIEW_MODE.augmentedRealityDoorsOnly,
]

export const MANUAL_CALCULATION_ROW_TYPES = {
  countertopRows: "countertopRows",
  backsplashRows: "backsplashRows",
  edgeRows: "edgeRows",
};

export const DIRECTION = {
  north: "north",
  east: "east",
  south: "south",
  west: "west",
};

export const MANUAL_CALCULATION_MEASURE = {
  length: "length",
  height: "height",
  width: "width",
  selectedFeature: "selectedFeature",
};

export const SQFT_BACKSPLASH_TYPES = ["4", "6", "18"];
export const SQFT_BACKSPLASH_TYPES_METRIC = ["100", "150", "600"];
export const SQFT_WALL_TYPES = ["wall"];
export const SQFT_MEASURE_UNIT = {
  imperial: "Imperial",
  metric: "Metric",
};
export const FREE_DRAW_TYPE = {
  shape: "shape",
  shapeFreeForm: "shapeFreeForm",
  wall: "wall",
};

export const CONTEXT_MENU_TYPE = {
  list: "list",
  buttons: "buttons",
};

export const SQFT_FEATURES = {
  bumpouts: 'bumpouts',
  countertop: 'countertop',
  center_island_countertop: 'center_island_countertop',
  slabs: 'slabs',
  backsplashes: 'backsplashes',
  edges: 'edges',
  radius: 'radius',
  corners: 'corners',
  shower_wall: 'shower_wall',
  shower_floor: 'shower_floor',
  kitchen_floor: 'kitchen_floor',
  vanity_accent: 'vanity_accent',
  vanity_countertop: 'vanity_countertop',
  vanity_backsplash: 'vanity_backsplash',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  shower_wall_accent: 'shower_wall_accent',
  accent_wall: 'accent_wall',
  bathroom_floor: 'bathroom_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
  front_wall: 'front_wall',
  top_cabinet: 'top_cabinet',
  bottom_cabinet: 'bottom_cabinet',
  upper_cabinet_boxes: 'upper_cabinet_boxes',
  top_handle: 'top_handle',
  lower_cabinet_boxes: 'lower_cabinet_boxes',
  bottom_handle: 'bottom_handle',
  tall_cabinet_boxes: 'tall_cabinet_boxes',
  crown_molding: 'crown_molding',
  handle: 'handle',
  underlayment: 'underlayment',
  wall_door_end_accessory: 'wall_door_end_accessory',
  base_door: 'base_door',
  island_panel: 'island_panel',
  refridgerator_panel: 'refridgerator_panel',
  end_cap: 'end_cap',
  hinge: 'hinge',
};

export const DEFAULT_EXPORTED_SQFT_FEATURES = [
  SQFT_FEATURES.crown_molding,
  SQFT_FEATURES.radius,
  SQFT_FEATURES.corners,
  SQFT_FEATURES.underlayment,
  SQFT_FEATURES.bumpouts,
]

export const PARENT_KEYS_WITH_COMBINED_FEATURES_IN_CART = [
  'edges',
  'backsplashes',
  'countertop',
  'center_island_countertop',
  'radius',
  'corners',
  'slabs',
  'vanity_countertop',
  'vanity_backsplash',
  'shower_wall',
  'shower_interior_wall',
  'shower_interior_wall_accent',
  'accent_wall',
  'shower_floor',
  'bathroom_floor',
  'kitchen_floor',
  'wall_a',
  'wall_b',
  'wall_c',
  'front_wall',
];

export const END_CAP_CABINETS_PART_IDS = [
  SQFT_FEATURES.wall_door_end_accessory,
  SQFT_FEATURES.base_door,
  SQFT_FEATURES.island_panel,
  SQFT_FEATURES.refridgerator_panel,
];

export const END_CAP_AREA_PART_IDS = [
  SQFT_FEATURES.end_cap,
];

export const END_CAP_PART_IDS = [
  ...END_CAP_CABINETS_PART_IDS,
  ...END_CAP_AREA_PART_IDS,
];

export const SQFT_PARENT_FEATURE_GROUP_PART_IDS = {
  upper_cabinet_boxes: 'top_cabinet',
  tall_cabinet_boxes: 'tall_cabinet',
  lower_cabinet_boxes: 'bottom_cabinet',
}

export const SQFT_CHILD_FEATURE_GROUP_PART_IDS = {
  top_cabinet: 'upper_cabinet_boxes',
  tall_cabinet: 'tall_cabinet_boxes',
  bottom_cabinet: 'lower_cabinet_boxes',
}

export const SQFT_AREA_TYPE_PART_IDS = {
  shower_wall: 'shower_wall',
  shower_floor: 'shower_floor',
  kitchen_floor: 'kitchen_floor',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  shower_wall_accent: 'shower_wall_accent',
  accent_wall: 'accent_wall',
  bathroom_floor: 'bathroom_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
};

export const COUNTERTOP_LABELS = {
  center_island_countertop: 'center_island_countertop',
  countertop: 'countertop',
  vanity_countertop: 'vanity_countertop',
  vanity_accent: 'vanity_accent',
  shower_wall: 'shower_wall',
  shower_wall_accent: 'shower_wall_accent',
  shower_interior_wall: 'shower_interior_wall',
  shower_interior_wall_accent: 'shower_interior_wall_accent',
  accent_wall: 'accent_wall',
  shower_floor: 'shower_floor',
  bathroom_floor: 'bathroom_floor',
  kitchen_floor: 'kitchen_floor',
  wall_a: 'wall_a',
  wall_b: 'wall_b',
  wall_c: 'wall_c',
  front_wall: 'front_wall',
};

export const CABINET_PART_IDS_THAT_CAN_HAVE_HANDLES = [
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
]

export const HANDLE_TO_CABINETS = {
  [SQFT_FEATURES.top_handle]: [SQFT_FEATURES.upper_cabinet_boxes],
  [SQFT_FEATURES.bottom_handle]: [SQFT_FEATURES.lower_cabinet_boxes, SQFT_FEATURES.tall_cabinet_boxes],
  [SQFT_FEATURES.handle]: [SQFT_FEATURES.upper_cabinet_boxes, SQFT_FEATURES.lower_cabinet_boxes],
};

export const CABINETS_TO_HANDLE = {
  [SQFT_FEATURES.upper_cabinet_boxes]: SQFT_FEATURES.top_handle,
  [SQFT_FEATURES.lower_cabinet_boxes]: SQFT_FEATURES.bottom_handle,
  [SQFT_FEATURES.tall_cabinet_boxes]: SQFT_FEATURES.bottom_handle,
};

export const CABINET_COMMON_COLOR_PART_IDS = [
  SHAPE_PART_ID.top_cabinet,
  SHAPE_PART_ID.bottom_cabinet,
  SHAPE_PART_ID.tall_cabinet,
  SHAPE_PART_ID.tall_cabinet_boxes,
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
];

export const FEATURE_QUANTITY_UNITS = [
  SHAPE_PART_ID.upper_cabinet_boxes,
  SHAPE_PART_ID.lower_cabinet_boxes,
  SHAPE_PART_ID.tall_cabinet_boxes
];

export const BACKSPLASH_LABELS = {
  backsplash: 'backsplash',
  backsplashes: 'backsplashes',
  vanity_backsplash: 'vanity_backsplash',
};

export const EDGE_LABELS = {
  edge: 'edge',
  edge_profile: 'edge_profile',
  center_island_edge: 'center_island_edge',
};

export const CORNER_LABELS = {
  radius: 'radius',
  corner: 'corner',
};

// export const FEATURES_WITH_0_VALUE_FOR_THE_SLABS = [
//   SQFT_FEATURES.backsplashes,
//   SQFT_FEATURES.countertop,
//   SQFT_FEATURES.center_island_countertop,
//   SQFT_FEATURES.shower_wall,
//   SQFT_FEATURES.shower_floor,
//   SQFT_FEATURES.kitchen_floor,
//   SQFT_FEATURES.vanity_countertop,
//   SQFT_FEATURES.vanity_backsplash,
//   SQFT_FEATURES.shower_interior_wall,
//   SQFT_FEATURES.shower_interior_wall_accent,
//   SQFT_FEATURES.bathroom_floor,
//   SQFT_FEATURES.wall_a,
//   SQFT_FEATURES.wall_b,
//   SQFT_FEATURES.wall_c
// ];

export const SHAPE_PART_IDS_USING_SAME_COLOR = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
  waterfallPiece: SHAPE_PART_ID.waterfallPiece,
  backsplashPiece: SHAPE_PART_ID.backsplashPiece,
  seamPiece: SHAPE_PART_ID.seamPiece,
}

export const FEATURES_WITH_0_VALUE_FOR_THE_SLABS = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
}

export const ALLOWED_LABEL_NAV_ITEMS = {
  ...COUNTERTOP_LABELS,
  ...BACKSPLASH_LABELS,
  ...CABINET_LABELS,
  ...SQFT_AREA_TYPE_PART_IDS,
  ...END_CAP_PART_IDS
}

export const POINT_PROPERTY = {
  angle: 'angle',         // 45 degCorner
  arcLength: 'arcLength', // Radius
}

export const RESOURCE_TYPE = {
  attachedToLine: 'attachedToLine',
  waterfallSectionsData: 'waterfallSectionsData',
  underlaymentSections: 'underlaymentSections',
  selectedFeature: null
}

export const RESOURCE_ATTACHED_TO_TYPE = {
  edge: 'edge',
  backsplash: 'backsplash',
  wall: 'wall',
  mitered: 'mitered',
  underlayment: 'underlayment',
  bumpout: 'bumpout',
  waterfall: 'waterfall',
  crown_molding: 'crown_molding',
  end_cap: 'end_cap',
}

export const RESOURCE_ATTACHED_TO_NAME = {
  waterfall: 'Waterfall',
}

export const WORKSPACE_RESOURCES = {
  spacers: 'spacers',
  handles: 'handles',
  hinge: 'hinge',
  crownMolding: 'crownMolding',
  walls: 'walls',
  shapeColors: 'shapeColors',
  waterfall: 'waterfall',
  removedFeatures: 'removedFeatures',
  snappedShapeGroups: 'snappedShapeGroups',
  selectedShapes: 'selectedShapes',
  images3d: 'images3d',
}

/**
 * Should be unique
 * @type {{peninsulaUnderwrap: string, underlayment: string, waterfall: string, cabinetReturn: string, overhangReturn: string}}
 */
export const WATERFALL_SHAPES_KEY = {
  cabinetReturn: 'Cabinet Return',
  waterfall: 'Waterfall Panel',
  overhangReturn: 'Overhang Return',
  underlayment: 'Underlayment',
  peninsulaUnderwrap: 'Ppeninsula Underwrap',
}

export const WATERFALL_SHAPES_NAME = {
  cabinetReturn: 'Cabinet Return',
  waterfall: 'Waterfall Panel',
  overhangReturn: 'Overhang Return',
  underlayment: 'Underlayment',
  peninsulaUnderwrap: 'Underlayment',
}

export const SQFT_GROUP = {
  area: 'area',
  cabinets: 'cabinets',
  default: 'default',
}

export const SQFT_AR3D_POPUP_CONTENT_TYPE = {
  ar: 'ar',
  threeD: 'threeD',
}

export const SQFT_AR3D_GLB_VIEWER = {
  singleModel: 'singleModel',
  separateModels: 'separateModels',
}

export const MITER_UNDERWRAP_EDGE_NAMES = [
  "miter underwrap"
];

export const MITER_EDGE_NAMES = [
  'Miter 1 1/2"',
  'Miter 2"-3"',
  'Miter 4"-6"',
  'Miter Edge',
  'Mitered Edge',
  'Rimrock - 981',
  'Ingletado',
  'Inglete',
  'Inglete.',
]

export const WATERFALL_OVERLAY_TYPE = {
  waterfall: 'waterfall',
  peninsulaUnderwrap: 'peninsulaUnderwrap',
}

export const MITERED_OVERLAY_TYPE = {
  mitered: "mitered",
  underlayment: "underlayment",
}

export const APPLIANCES_THAT_SHOULD_RENDER_MEASUREMENTS_INSIDE_THE_SHAPE = [
  SQFT_APPLIANCES.sink,
  SQFT_APPLIANCES.doubleSink,
  SQFT_APPLIANCES.stovetop
]

export const CABINET_FILTER_NAMES = {
  knobs: 'Number_of_Knobs',
  hinges: 'Number_of_Hinges',
  slideSets: 'Numbe_of_Slide_Sets',
  doors: 'Number_of_Doors',
  drawers: 'Number_of_Drawers',
}

export const CABINET_SET3 = {
  "bumpouts": [],
  "canvasImage": "",
  "sqFtSlabImage": "",
  "sqFtSlabCalcImage": "",
  "sqftApplianceImages": "",
  "images3D": "",
  "slabImages": [],
  "measureUnit": "Imperial",
  "sinks": [],
  "radii": [],
  "corners": [],
  "totalInches": 7540.384732531849,
  "shapeLength": 7,
  "objIds": 12,
  "removedFeatures": [],
  "textBoxes": [],
  "slabAdditionalShapesList": [],
  "slabImagesTotalArea": [],
  "squareFeet": 53,
  "countertops": [
    {
      "pos": {
        "x": 77.93333333333332,
        "y": -100.46666666666664
      },
      "slabPos": {
        "x": -21,
        "y": -106.66666666666667
      },
      "id": 12,
      "featureId": 381183142,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParent": null,
      "lines": [
        {
          "id": "647a01fa-b2c5-4603-a2bb-a07b78d411ce",
          "from": {
            "id": "7757a1c7-4343-4d9a-9f60-4125938a8d99",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "450bc4f0-4b07-4821-8491-049540b8e489",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "13b047b0-7d01-4203-8f21-1d2d53bd4e2f",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "447973b0-7013-43a1-bd14-cc1c62c93308",
          "from": {
            "id": "450bc4f0-4b07-4821-8491-049540b8e489",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5b6673db-26b9-4abb-a916-7b744fdc54fa",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "dbda4393-3a52-4eb0-96b2-c02638e47e84",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "16d395a2-3c2c-4fe4-bdac-bae16f2fe1b4",
          "from": {
            "id": "5b6673db-26b9-4abb-a916-7b744fdc54fa",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "73d327ed-e285-4747-ab65-7b4b3a38e48b",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "0e4430a1-9d88-4195-bd50-289e42818b74",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "a94d91d3-68c3-467d-a93a-7bc9988fb275",
          "from": {
            "id": "73d327ed-e285-4747-ab65-7b4b3a38e48b",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "7757a1c7-4343-4d9a-9f60-4125938a8d99",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "37253c2f-03db-40cc-ac71-1a480e531864",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 77.93333333333332,
          "y": -100.46666666666664
        },
        "intersectionPoints": [],
        "snappedWithShape": 5,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel SM-B42"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 381762693,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "id": "7757a1c7-4343-4d9a-9f60-4125938a8d99"
        },
        {
          "x": 42,
          "y": 0,
          "id": "450bc4f0-4b07-4821-8491-049540b8e489"
        },
        {
          "x": 42,
          "y": 24,
          "id": "5b6673db-26b9-4abb-a916-7b744fdc54fa"
        },
        {
          "x": 0,
          "y": 24,
          "id": "73d327ed-e285-4747-ab65-7b4b3a38e48b"
        }
      ]
    },
    {
      "pos": {
        "x": 119.93333333333332,
        "y": -100.46666666666664
      },
      "slabPos": {
        "x": 37.5,
        "y": -60.1
      },
      "id": 5,
      "featureId": 381672414,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParent": null,
      "lines": [
        {
          "id": "7882938b-fa71-466a-ad7e-1517aeab583b",
          "from": {
            "id": "8329535a-7b11-48b8-941b-fb2397b280ce",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5d8d5da8-afd0-441e-8277-aa8b085dfa5d",
            "x": 45,
            "y": 0,
            "pos": {
              "x": 45,
              "y": 0
            },
            "posSlab": {
              "x": 45,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "a5c13d55-cf69-4719-84a7-f4c293c97edd",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "c67aca45-a645-43c4-99df-2955257ebcd2",
          "from": {
            "id": "5d8d5da8-afd0-441e-8277-aa8b085dfa5d",
            "x": 45,
            "y": 0,
            "pos": {
              "x": 45,
              "y": 0
            },
            "posSlab": {
              "x": 45,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "4792d285-2fe0-4dc7-8cf9-d7dc2866b9a5",
            "x": 45,
            "y": 24,
            "pos": {
              "x": 45,
              "y": 24
            },
            "posSlab": {
              "x": 45,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "be2a5262-5eba-4288-b07b-4ed2ff4d3145",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "d4aedcd1-8875-4716-8a0f-16361936749d",
          "from": {
            "id": "4792d285-2fe0-4dc7-8cf9-d7dc2866b9a5",
            "x": 45,
            "y": 24,
            "pos": {
              "x": 45,
              "y": 24
            },
            "posSlab": {
              "x": 45,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "7d4f9cdd-1a7e-44a5-879f-44068e01e4f1",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 24,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c714fed9-f24c-4d5e-a06e-6e6b2e949fc2",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "3c409f1b-74ff-4042-8ad4-5d16d11d3580",
          "from": {
            "id": "7d4f9cdd-1a7e-44a5-879f-44068e01e4f1",
            "x": 24,
            "y": 24,
            "pos": {
              "x": 24,
              "y": 24
            },
            "posSlab": {
              "x": 24,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "fbffd1f2-c01b-40d7-93a2-eecf6eebf958",
            "x": 24,
            "y": 45,
            "pos": {
              "x": 24,
              "y": 45
            },
            "posSlab": {
              "x": 24,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "da695b3d-9f91-4bba-9fa4-1cb242afef45",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2445f310-99ee-490e-a3ee-373be5aa17e9",
          "from": {
            "id": "fbffd1f2-c01b-40d7-93a2-eecf6eebf958",
            "x": 24,
            "y": 45,
            "pos": {
              "x": 24,
              "y": 45
            },
            "posSlab": {
              "x": 24,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "a18885db-6594-4e75-a214-15df5ea51f82",
            "x": 0,
            "y": 45,
            "pos": {
              "x": 0,
              "y": 45
            },
            "posSlab": {
              "x": 0,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "6c9d0041-9c66-48c5-bb4f-117c2d88ed8a",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "29c6ade2-7972-46b1-89d5-d5ee47620a4d",
          "from": {
            "id": "a18885db-6594-4e75-a214-15df5ea51f82",
            "x": 0,
            "y": 45,
            "pos": {
              "x": 0,
              "y": 45
            },
            "posSlab": {
              "x": 0,
              "y": 45
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "8329535a-7b11-48b8-941b-fb2397b280ce",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "bddde005-44cb-4f3a-9e02-e4ce18508b56",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 45,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 119.93333333333332,
          "y": -100.46666666666664
        },
        "intersectionPoints": [],
        "snappedWithShape": 12,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 45,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel BBC45-48FHLRB"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel BBC45-48FHLRB"
          ],
          "Width": [
            "45"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "BBC45-48FHLRB"
          ],
          "Shape": [
            "BBC45-48FHLRB"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "SpecialShape": [
            "LowerLCorner"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "45"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "LowerLCorner"
      },
      "relatedParentFeatureId": 381762693,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "id": "8329535a-7b11-48b8-941b-fb2397b280ce"
        },
        {
          "x": 45,
          "y": 0,
          "id": "5d8d5da8-afd0-441e-8277-aa8b085dfa5d"
        },
        {
          "x": 45,
          "y": 24,
          "id": "4792d285-2fe0-4dc7-8cf9-d7dc2866b9a5"
        },
        {
          "x": 24,
          "y": 24,
          "id": "7d4f9cdd-1a7e-44a5-879f-44068e01e4f1"
        },
        {
          "x": 24,
          "y": 45,
          "id": "fbffd1f2-c01b-40d7-93a2-eecf6eebf958"
        },
        {
          "x": 0,
          "y": 45,
          "id": "a18885db-6594-4e75-a214-15df5ea51f82"
        }
      ]
    },
    {
      "pos": {
        "x": 38.20000000000003,
        "y": -101.06666666666663
      },
      "slabPos": {
        "x": 39,
        "y": -49.6
      },
      "id": 6,
      "featureId": 381183142,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParent": null,
      "lines": [
        {
          "id": "ac535fb8-daba-4237-a079-9c0a9954b91f",
          "from": {
            "id": "c9f4f50e-6454-4f3d-b8af-d7c2b620fe3f",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "4102b6db-3cc7-4c03-ba27-ac7befbc9279",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "22915925-981f-4852-ab18-5c98a860e57c",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2915c96e-87a9-42fa-bcfa-097e314b068e",
          "from": {
            "id": "4102b6db-3cc7-4c03-ba27-ac7befbc9279",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6c3072f1-d3f3-476a-8d62-6041f21999f6",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "0fdaa99c-0c3c-49a3-afb6-d5e5fbb84af8",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "975a7d08-decb-4044-846f-7cf6ab05534c",
          "from": {
            "id": "6c3072f1-d3f3-476a-8d62-6041f21999f6",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "104b7524-8327-4458-a54b-26141bec2eec",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "cbd744a8-3640-4fd6-8538-cbb1c609cb77",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "f4e17ba9-6f1b-4766-bff7-d86602a6f100",
          "from": {
            "id": "104b7524-8327-4458-a54b-26141bec2eec",
            "x": 0,
            "y": 24,
            "pos": {
              "x": 0,
              "y": 24
            },
            "posSlab": {
              "x": 0,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "c9f4f50e-6454-4f3d-b8af-d7c2b620fe3f",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "2bfe82a8-8e76-4c02-9c4d-2932511ee1e2",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 35.93333333333333,
          "y": -100.46666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 12,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel SM-B42"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel SM-B42"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "SM-B42"
          ],
          "Shape": [
            "SM-B42"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "2"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 381762693,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "id": "c9f4f50e-6454-4f3d-b8af-d7c2b620fe3f"
        },
        {
          "x": 42,
          "y": 0,
          "id": "4102b6db-3cc7-4c03-ba27-ac7befbc9279"
        },
        {
          "x": 42,
          "y": 24,
          "id": "6c3072f1-d3f3-476a-8d62-6041f21999f6"
        },
        {
          "x": 0,
          "y": 24,
          "id": "104b7524-8327-4458-a54b-26141bec2eec"
        }
      ]
    },
    {
      "pos": {
        "x": -6.0666666666666575,
        "y": -100.46666666666665
      },
      "slabPos": {
        "x": 39,
        "y": -58.6
      },
      "id": 7,
      "featureId": 381672425,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParent": null,
      "lines": [
        {
          "id": "165ddbbe-5161-4aa6-ad24-6f5bb2dbd133",
          "from": {
            "id": "d1b66302-82de-4b57-8f70-38c836201254",
            "x": 12.3065,
            "y": 0,
            "pos": {
              "x": 12.3065,
              "y": 0
            },
            "posSlab": {
              "x": 12.3065,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "afb94d89-9ec9-4a59-9261-b6b746126b22",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "d30fc942-ba44-4a40-b9d4-06125d02a497",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "246453e1-e835-4841-8b49-8e9826c89584",
          "from": {
            "id": "afb94d89-9ec9-4a59-9261-b6b746126b22",
            "x": 42,
            "y": 0,
            "pos": {
              "x": 42,
              "y": 0
            },
            "posSlab": {
              "x": 42,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "dd4f428d-2e34-4a5e-b31a-7f81822e66ea",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "8b782418-71c8-4906-b258-9a883c1e14d7",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "777f1787-844c-4c1f-ad74-103b8c440607",
          "from": {
            "id": "dd4f428d-2e34-4a5e-b31a-7f81822e66ea",
            "x": 42,
            "y": 24,
            "pos": {
              "x": 42,
              "y": 24
            },
            "posSlab": {
              "x": 42,
              "y": 24
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "a9636338-80eb-4493-a7da-4ed87028321e",
            "x": 24,
            "y": 42,
            "pos": {
              "x": 24,
              "y": 42
            },
            "posSlab": {
              "x": 24,
              "y": 42
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "3b4fd3af-e212-4f50-9c5a-aa32bdbf040e",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "59f45381-6a35-4bd2-b230-7e9ead9e5612",
          "from": {
            "id": "a9636338-80eb-4493-a7da-4ed87028321e",
            "x": 24,
            "y": 42,
            "pos": {
              "x": 24,
              "y": 42
            },
            "posSlab": {
              "x": 24,
              "y": 42
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "6f04935b-3540-4294-b4cc-e8a9e95a4b58",
            "x": 0,
            "y": 42,
            "pos": {
              "x": 0,
              "y": 42
            },
            "posSlab": {
              "x": 0,
              "y": 42
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "0a0d3ded-0683-4fe9-86b3-d19e98e518ff",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "40fb4dd5-82c8-4a4f-a486-ed241767bd34",
          "from": {
            "id": "6f04935b-3540-4294-b4cc-e8a9e95a4b58",
            "x": 0,
            "y": 42,
            "pos": {
              "x": 0,
              "y": 42
            },
            "posSlab": {
              "x": 0,
              "y": 42
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "c5561c94-e740-4360-82a2-f8548e6f0b87",
            "x": 0,
            "y": 12.3065,
            "pos": {
              "x": 0,
              "y": 12.3065
            },
            "posSlab": {
              "x": 0,
              "y": 12.3065
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "2183cb80-52ae-4409-ab53-d569db21871d",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "691ccdc8-7e56-4b77-a086-07dc83714807",
          "from": {
            "id": "c5561c94-e740-4360-82a2-f8548e6f0b87",
            "x": 0,
            "y": 12.3065,
            "pos": {
              "x": 0,
              "y": 12.3065
            },
            "posSlab": {
              "x": 0,
              "y": 12.3065
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "d1b66302-82de-4b57-8f70-38c836201254",
            "x": 12.3065,
            "y": 0,
            "pos": {
              "x": 12.3065,
              "y": 0
            },
            "posSlab": {
              "x": 12.3065,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "5a8acee9-cada-4d78-be8c-110de6976c52",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "lower_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 42,
        "height": 34,
        "depth": 24
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -6.0666666666666575,
          "y": -100.46666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 6,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 42,
        "height": 34,
        "depth": 24,
        "diamondLength": 29.6935,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel DCB42LRB"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel DCB42LRB"
          ],
          "Width": [
            "42"
          ],
          "Height": [
            "34"
          ],
          "Depth": [
            "24"
          ],
          "SKU": [
            "DCB42LRB"
          ],
          "Shape": [
            "DCB42LRB"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "SpecialShape": [
            "LowerDimondShape"
          ],
          "DiamondLength": [
            "29.6935in"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "42"
            ],
            "Height": [
              "34"
            ],
            "Depth": [
              "24"
            ],
            "DiamondLength": [
              "29.6935in"
            ]
          }
        },
        "shapeLayout": "LowerDimondShape"
      },
      "relatedParentFeatureId": 381762693,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 12.3065,
          "y": 0,
          "id": "d1b66302-82de-4b57-8f70-38c836201254"
        },
        {
          "x": 42,
          "y": 0,
          "id": "afb94d89-9ec9-4a59-9261-b6b746126b22"
        },
        {
          "x": 42,
          "y": 24,
          "id": "dd4f428d-2e34-4a5e-b31a-7f81822e66ea"
        },
        {
          "x": 24,
          "y": 42,
          "id": "a9636338-80eb-4493-a7da-4ed87028321e"
        },
        {
          "x": 0,
          "y": 42,
          "id": "6f04935b-3540-4294-b4cc-e8a9e95a4b58"
        },
        {
          "x": 0,
          "y": 12.3065,
          "id": "c5561c94-e740-4360-82a2-f8548e6f0b87"
        }
      ]
    },
    {
      "pos": {
        "x": 66.53333333333335,
        "y": -99.33333333333329
      },
      "slabPos": {
        "x": 68.13333333333334,
        "y": -79.06666666666666
      },
      "id": 9,
      "featureId": 381183133,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParent": null,
      "lines": [
        {
          "id": "a41c77ab-2008-4ea5-b3b8-965943349ce6",
          "from": {
            "id": "2fe55550-d46f-4442-8231-44610f2cde3a",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3cbf3cd2-48f1-48df-839d-44faefc2b2fb",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "b3582108-71aa-4c6e-b6df-0553a381ca33",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "a670d4d5-37f4-4b9e-917c-b8081cbbd2d0",
          "from": {
            "id": "3cbf3cd2-48f1-48df-839d-44faefc2b2fb",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "36871fd9-8866-495c-aed1-c95115051230",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "1c31df18-ec68-4f44-9103-89aaf919cb28",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "2c715779-9dda-4267-b508-06b454b2935d",
          "from": {
            "id": "36871fd9-8866-495c-aed1-c95115051230",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "5b245f9e-32e5-4fc4-88e4-f03e7f5a021f",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "9f1ed23b-f565-4abe-9179-27085920a697",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "625a3b14-9432-412d-9d3e-64e78e4528bb",
          "from": {
            "id": "5b245f9e-32e5-4fc4-88e4-f03e7f5a021f",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "2fe55550-d46f-4442-8231-44610f2cde3a",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "b6b16ec2-2e3f-41a9-be82-feef6eb33739",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 36,
        "height": 42,
        "depth": 12
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 65.93333333333335,
          "y": -100.46666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 10,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 36,
        "height": 42,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel SM-W3642"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel SM-W3642"
          ],
          "Width": [
            "36"
          ],
          "Height": [
            "42"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SM-W3642"
          ],
          "Shape": [
            "SM-W3642"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "36"
            ],
            "Height": [
              "42"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 381762675,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "id": "2fe55550-d46f-4442-8231-44610f2cde3a"
        },
        {
          "x": 36,
          "y": 0,
          "id": "3cbf3cd2-48f1-48df-839d-44faefc2b2fb"
        },
        {
          "x": 36,
          "y": 12,
          "id": "36871fd9-8866-495c-aed1-c95115051230"
        },
        {
          "x": 0,
          "y": 12,
          "id": "5b245f9e-32e5-4fc4-88e4-f03e7f5a021f"
        }
      ]
    },
    {
      "pos": {
        "x": 28.933333333333362,
        "y": -99.06666666666665
      },
      "slabPos": {
        "x": 68.13333333333334,
        "y": -79.06666666666666
      },
      "id": 10,
      "featureId": 381183137,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParent": null,
      "lines": [
        {
          "id": "c7d0673f-c0b1-4e41-93a5-7dbe797c0c02",
          "from": {
            "id": "844238cb-c72c-422f-a4e1-6375df980944",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "3655728d-51cb-4842-aa0c-74e9fcae6ccc",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "c548ea6b-8a50-4519-a014-243925de5180",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "8d99dbbc-9a40-42b7-94aa-171633d87f60",
          "from": {
            "id": "3655728d-51cb-4842-aa0c-74e9fcae6ccc",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "676a53bb-28d2-401a-835e-57383804d3ea",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "9b9cb935-af2d-41c7-9247-7662901d48f1",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "8d9829de-6472-4963-950a-402efe78e8fe",
          "from": {
            "id": "676a53bb-28d2-401a-835e-57383804d3ea",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "8fb12eda-3755-416e-ba51-965155387f63",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "9585ae3e-578e-4d3c-b61b-e7af31ae5748",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "fda03198-c1f8-451c-8404-34df394ecc39",
          "from": {
            "id": "8fb12eda-3755-416e-ba51-965155387f63",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "844238cb-c72c-422f-a4e1-6375df980944",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "0b7dc8be-4e89-4656-96de-c6f475f1b00a",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 36,
        "height": 36,
        "depth": 12
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": 29.93333333333333,
          "y": -100.46666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 9,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 36,
        "height": 36,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel SM-W3636"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel SM-W3636"
          ],
          "Width": [
            "36"
          ],
          "Height": [
            "36"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SM-W3636"
          ],
          "Shape": [
            "SM-W3636"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "2"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "36"
            ],
            "Height": [
              "36"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 381762675,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "id": "844238cb-c72c-422f-a4e1-6375df980944"
        },
        {
          "x": 36,
          "y": 0,
          "id": "3655728d-51cb-4842-aa0c-74e9fcae6ccc"
        },
        {
          "x": 36,
          "y": 12,
          "id": "676a53bb-28d2-401a-835e-57383804d3ea"
        },
        {
          "x": 0,
          "y": 12,
          "id": "8fb12eda-3755-416e-ba51-965155387f63"
        }
      ]
    },
    {
      "pos": {
        "x": -6.799999999999994,
        "y": -99.33333333333329
      },
      "slabPos": {
        "x": 68.13333333333334,
        "y": -79.06666666666666
      },
      "id": 11,
      "featureId": 381183139,
      "colorSet": null,
      "isHidden": false,
      "shapePieces": [],
      "seamCutPoints": [],
      "shapeParent": null,
      "lines": [
        {
          "id": "45e1a826-e059-49cb-a68d-db6575a4c909",
          "from": {
            "id": "176fe8da-27cd-41c1-89de-8dafd037ae59",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "32b73148-443d-43b2-8b37-2871e61bb3cc",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "f96261e8-94c2-438a-a40a-d7a8a8bdd56d",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "79506af2-6dd7-444a-93d3-1780eb565d0e",
          "from": {
            "id": "32b73148-443d-43b2-8b37-2871e61bb3cc",
            "x": 36,
            "y": 0,
            "pos": {
              "x": 36,
              "y": 0
            },
            "posSlab": {
              "x": 36,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "righttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "c1c62f14-6557-4f83-a59c-3ac8af699504",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "4092e21b-71a5-4892-9322-ac95ab0ad4ce",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "c4bbbb29-cefd-4923-b53d-853a7f6ce8fc",
          "from": {
            "id": "c1c62f14-6557-4f83-a59c-3ac8af699504",
            "x": 36,
            "y": 12,
            "pos": {
              "x": 36,
              "y": 12
            },
            "posSlab": {
              "x": 36,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "rightbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "73ac4a3f-49b8-4ab2-8e2e-730a5d6358c9",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "435366c8-54f5-42ae-820d-51e28aef018f",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        },
        {
          "id": "9a87fba6-fa9c-4913-8861-66eb31350cc5",
          "from": {
            "id": "73ac4a3f-49b8-4ab2-8e2e-730a5d6358c9",
            "x": 0,
            "y": 12,
            "pos": {
              "x": 0,
              "y": 12
            },
            "posSlab": {
              "x": 0,
              "y": 12
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "leftbottom",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "to": {
            "id": "176fe8da-27cd-41c1-89de-8dafd037ae59",
            "x": 0,
            "y": 0,
            "pos": {
              "x": 0,
              "y": 0
            },
            "posSlab": {
              "x": 0,
              "y": 0
            },
            "arcLength": 0,
            "angle": 0,
            "pointDirection": "lefttop",
            "rotateAnglePart": null,
            "angleIsChanged": false,
            "renderAngleCircle": false,
            "renderAngleArc": false,
            "featureId": null
          },
          "bumpout": null,
          "mitered": null,
          "underlayment": null,
          "waterfallData": null,
          "label": null,
          "titleOverlay": null,
          "overlay": null,
          "lineCorner": {
            "id": "112f0193-ec8e-4ed0-9519-ebdf08328c60",
            "_state": {
              "mouseDown": false,
              "isHovering": false,
              "isCornerLineHovering": false,
              "withEdge": false,
              "withBacksplash": false,
              "withWall": false,
              "withId": null,
              "backsplashHeight": null,
              "isWithMitered": false
            },
            "miteredOverlay": null
          },
          "state": {
            "mousePos": {},
            "mouseDown": false,
            "mouseDownPosition": null,
            "isHovering": false,
            "withEdge": false,
            "withBacksplash": false,
            "withWall": false,
            "withBumpout": false,
            "isWithMitered": false,
            "isWithUnderlayment": false,
            "isWithWaterfallEdge": false,
            "isWithPeninsulaUnderwrapEdge": false,
            "isWithFakeEdge": false,
            "withId": null,
            "attachedHandleId": null,
            "attachedHandleUrl": null,
            "attachedCrownMoldingFeatureId": null,
            "attachedCrownMoldingUrl": null,
            "backsplashFeatureId": null,
            "backsplashHeight": 0,
            "backsplashName": "",
            "backsplashType": "",
            "attachedItems": {
              "isWithCrownMolding": false,
              "isWithEndCap": false
            },
            "movePointDistance": 0,
            "angleLinePoints": {},
            "slabModeSkipMiteredEdgeCreation": false,
            "isHiddenForever": false,
            "seamCutPoint": null
          }
        }
      ],
      "shapeType": "square",
      "rotatedDegrees": 0,
      "rotatedDegreesSlab": 0,
      "partId": "upper_cabinet_boxes",
      "qtCatName": "Kitchen",
      "fromLayout": null,
      "squareFeet": 1,
      "quantity": 1,
      "isDisabledInPopup": false,
      "rotateAngleParts": [],
      "isPointsChanged": true,
      "isPositionChanged": true,
      "isResetSlabModePopupWasDisplayed": false,
      "shapeSlab": {
        "absolutePosition": null
      },
      "shapeCabinet": {
        "width": 36,
        "height": 30,
        "depth": 12
      },
      "shapeAbsolute": {
        "absolutePosition": {
          "x": -6.06666666666666,
          "y": -100.46666666666665
        },
        "intersectionPoints": [],
        "snappedWithShape": 10,
        "snappedShapeGroup": 31
      },
      "shapeParams": {
        "shapeCabinet": true,
        "canSnap": true,
        "width": 36,
        "height": 30,
        "depth": 12,
        "diamondLength": 0,
        "thirdPartyAR3DMetaData": {
          "ActualDisplayedName": [
            "Hamilton Flat Panel SW-WBC3630"
          ],
          "DisplayedName": [
            "Hamilton Flat Panel SW-WBC3630"
          ],
          "Width": [
            "36"
          ],
          "Height": [
            "30"
          ],
          "Depth": [
            "12"
          ],
          "SKU": [
            "SW-WBC3630"
          ],
          "Shape": [
            "SW-WBC3630"
          ],
          "DoorStyle": [
            "Hamilton Flat Panel"
          ],
          "Door": [
            "1"
          ],
          "Drawer": [
            "0"
          ],
          "filters": {
            "Style": [
              "Hamilton Flat Panel"
            ],
            "Width": [
              "36"
            ],
            "Height": [
              "30"
            ],
            "Depth": [
              "12"
            ]
          }
        },
        "shapeLayout": "rectangle"
      },
      "relatedParentFeatureId": 381762675,
      "slabModeCoreParentId": null,
      "parentPartId": null,
      "slabParentPartId": null,
      "shouldUseSlabPricing": false,
      "originalPointsCoords": [
        {
          "x": 0,
          "y": 0,
          "id": "176fe8da-27cd-41c1-89de-8dafd037ae59"
        },
        {
          "x": 36,
          "y": 0,
          "id": "32b73148-443d-43b2-8b37-2871e61bb3cc"
        },
        {
          "x": 36,
          "y": 12,
          "id": "c1c62f14-6557-4f83-a59c-3ac8af699504"
        },
        {
          "x": 0,
          "y": 12,
          "id": "73ac4a3f-49b8-4ab2-8e2e-730a5d6358c9"
        }
      ]
    }
  ],
  "manualCalculate": false,
  "controllers": {
    "walls": [],
    "snappedShapeGroups": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31
    ],
    "handles": [],
    "hinge": []
  },
  "underlayment": []
}

export const CABINET_SET2 = [
  {
    "shapeId": 1,
    "partId": "lower_cabinet_boxes",
    "x": -45.13333333333333,
    "y": 0,
    "z": -34.4666666666667,
    "rotation": 90,
    "url": "https://d1mb1i73swc8dz.cloudfront.net/ar-composer-v2/models/All-Top Cabinet-Fairbank-Barcelona 2-H4818.glb",
    "material_url": "https://d1mb1i73swc8dz.cloudfront.net/ar-composer-v2/textures/All-Cabinet-Dutch Gray-Trend.glb",
    "framed": false,
    "frame_width": 0.75,
    "frame_height": 0.25,
    "target_width": 48,
    "target_depth": 12,
    "target_height": 18,
    "width": 48,
    "height": 18,
    "depth": 12,
    "contour_points": [
      {
        "x": 18,
        "y": 30,
        "id": "13c5f884-cc36-4537-afab-9e73716b37ce"
      },
      {
        "x": 18,
        "y": -18,
        "id": "67cba080-e63f-4367-a5d6-3294d212aaf1"
      },
      {
        "x": 30,
        "y": -18,
        "id": "ba70c7da-e2a9-4914-afb8-9c435cbde0f7"
      },
      {
        "x": 30,
        "y": 30,
        "id": "11c8255e-c2f2-4afe-bca8-3dff28be49d1"
      }
    ],
    "original_points": [
      {
        "x": 0,
        "y": 0,
        "id": "13c5f884-cc36-4537-afab-9e73716b37ce"
      },
      {
        "x": 48,
        "y": 0,
        "id": "67cba080-e63f-4367-a5d6-3294d212aaf1"
      },
      {
        "x": 48,
        "y": 12,
        "id": "ba70c7da-e2a9-4914-afb8-9c435cbde0f7"
      },
      {
        "x": 0,
        "y": 12,
        "id": "11c8255e-c2f2-4afe-bca8-3dff28be49d1"
      }
    ],
    "featureId": 272476414,
    "parentFeatureId": 272289587,
    "shapeLayout": "rectangle"
  },
  {
    "shapeId": 10,
    "partId": "upper_cabinet_boxes",
    "x": 160.53333333333316,
    "y": 52,
    "z": 3.4359833333333327,
    "rotation": 270,
    "url": "https://d1mb1i73swc8dz.cloudfront.net/ar-composer-v2/models/All-Top Cabinet-Fairbank-Barcelona 2-H4818.glb",
    "material_url": "https://d1mb1i73swc8dz.cloudfront.net/ar-composer-v2/textures/All-Cabinet-Dutch Gray-Trend.glb",
    "framed": false,
    "frame_width": 0.75,
    "frame_height": 0.25,
    "target_width": 48,
    "target_depth": 12,
    "target_height": 18,
    "width": 48,
    "height": 18,
    "depth": 12,
    "contour_points": [
      {
        "x": 30,
        "y": -18,
        "id": "fb95bdb3-57ac-4b9e-9620-3aea19504c2b"
      },
      {
        "x": 30,
        "y": 30,
        "id": "f2939976-4d3e-48dc-be86-0f4b0f4894ef"
      },
      {
        "x": 18,
        "y": 30,
        "id": "1df267ef-bd5d-41ac-a492-4d29480d2ff3"
      },
      {
        "x": 18,
        "y": -18,
        "id": "c6be3316-86e1-4872-ad32-38bb00c70d76"
      }
    ],
    "original_points": [
      {
        "x": 0,
        "y": 0,
        "id": "fb95bdb3-57ac-4b9e-9620-3aea19504c2b"
      },
      {
        "x": 48,
        "y": 0,
        "id": "f2939976-4d3e-48dc-be86-0f4b0f4894ef"
      },
      {
        "x": 48,
        "y": 12,
        "id": "1df267ef-bd5d-41ac-a492-4d29480d2ff3"
      },
      {
        "x": 0,
        "y": 12,
        "id": "c6be3316-86e1-4872-ad32-38bb00c70d76"
      }
    ],
    "featureId": 272476414,
    "parentFeatureId": 272289587,
    "shapeLayout": "rectangle"
  },
  {
    "shapeId": 9,
    "partId": "upper_cabinet_boxes",
    "x": 115.33333333333331,
    "y": 52,
    "z": 99.10529999999989,
    "rotation": 180,
    "url": "https://d1mb1i73swc8dz.cloudfront.net/ar-composer-v2/models/All-Top Cabinet-Fairbank-Barcelona 2-H4818.glb",
    "material_url": "https://d1mb1i73swc8dz.cloudfront.net/ar-composer-v2/textures/All-Cabinet-Dutch Gray-Trend.glb",
    "framed": false,
    "frame_width": 0.75,
    "frame_height": 0.25,
    "target_width": 48,
    "target_depth": 12,
    "target_height": 18,
    "width": 48,
    "height": 18,
    "depth": 12,
    "contour_points": [
      {
        "x": 48,
        "y": 12,
        "id": "b091744b-00bb-4f92-9e69-b447e6e4def6"
      },
      {
        "x": 0,
        "y": 12,
        "id": "4325e622-93fb-414c-b662-f83a86dee364"
      },
      {
        "x": 0,
        "y": 0,
        "id": "300f3d60-3ca2-45c5-9016-1a40122bd839"
      },
      {
        "x": 48,
        "y": 0,
        "id": "7dce39ce-5fb3-4655-bc1c-066af713d4e8"
      }
    ],
    "original_points": [
      {
        "x": 0,
        "y": 0,
        "id": "b091744b-00bb-4f92-9e69-b447e6e4def6"
      },
      {
        "x": 48,
        "y": 0,
        "id": "4325e622-93fb-414c-b662-f83a86dee364"
      },
      {
        "x": 48,
        "y": 12,
        "id": "300f3d60-3ca2-45c5-9016-1a40122bd839"
      },
      {
        "x": 0,
        "y": 12,
        "id": "7dce39ce-5fb3-4655-bc1c-066af713d4e8"
      }
    ],
    "featureId": 272476414,
    "parentFeatureId": 272289587,
    "shapeLayout": "rectangle"
  },
  {
    "featureId": 272209426,
    "shapeId": 8,
    "partId": "hood",
    "x": 16.333333333333343,
    "y": 52,
    "z": 99.10794999999992,
    "rotation": 90,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Hood-GE JVW5361 BS.glb",
    "width": 30,
    "height": 12,
    "depth": 15.4053
  },
  {
    "featureId": 272209426,
    "shapeId": 7,
    "partId": "hood",
    "x": 167.83068333333313,
    "y": 52,
    "z": 66.43863333333334,
    "rotation": 180,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Hood-GE JVW5361 BS.glb",
    "width": 30,
    "height": 12,
    "depth": 15.4053
  },
  {
    "featureId": 272209426,
    "shapeId": 6,
    "partId": "hood",
    "x": -6.230683333333214,
    "y": 52,
    "z": -38.06666666666658,
    "rotation": 0,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Hood-GE JVW5361 BS.glb",
    "width": 30,
    "height": 12,
    "depth": 15.4053
  },
  {
    "featureId": 272209426,
    "shapeId": 5,
    "partId": "hood",
    "x": 143.2666666666667,
    "y": 52,
    "z": -71.96931666666698,
    "rotation": -90,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Hood-GE JVW5361 BS.glb",
    "width": 30,
    "height": 12,
    "depth": 15.4053
  },
  {
    "featureId": 374232550,
    "shapeId": 4,
    "partId": "fridge",
    "x": -2.356533333333223,
    "y": 0,
    "z": 42.907483333333424,
    "rotation": 0,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Fridge-ZLINE RFM-W 36 SS.glb",
    "width": 36,
    "height": 12,
    "depth": 29.1536
  },
  {
    "featureId": 374232550,
    "shapeId": 3,
    "partId": "fridge",
    "x": 163.9565333333332,
    "y": 0,
    "z": -14.587216666666674,
    "rotation": 180,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Fridge-ZLINE RFM-W 36 SS.glb",
    "width": 36,
    "height": 12,
    "depth": 29.1536
  },
  {
    "featureId": 374232550,
    "shapeId": 2,
    "partId": "fridge",
    "x": 49.33333333333332,
    "y": 0,
    "z": 99.08209999999991,
    "rotation": 90,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Fridge-ZLINE RFM-W 36 SS.glb",
    "width": 36,
    "height": 12,
    "depth": 29.1536
  },
  {
    "featureId": 374232550,
    "shapeId": 1,
    "partId": "fridge",
    "x": 62.26666666666674,
    "y": 0,
    "z": -71.99516666666699,
    "rotation": -90,
    "url": "https://qc-3dfiles.s3.amazonaws.com/ar-composer/All-Fridge-ZLINE RFM-W 36 SS.glb",
    "width": 36,
    "height": 12,
    "depth": 29.1536
  }
]
